<template>
  <div v-if="text" :class="bemBlock">
    <span :class="bemElement('text')" v-html="text" />
    <div
      v-show="tooltip"
      ref="PriceMsgTooltip"
      :class="bemElement('tooltip-container')"
      @mouseleave="handleHideTooltip"
      @mouseenter="handleShowTooltip"
    >
      <i :class="bemElement('icon')" @click="handleShowTooltip" />
    </div>
  </div>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';

const { createTooltip } = require('../../components/tooltips');

export default {
  name: 'BaseInfoMsg',

  mixins: [bemClassesMixin],

  props: {
    text: {
      type: String,
      default: null,
    },
    textTooltip: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      tooltip: null,
    };
  },

  mounted() {
    this.insertTooltip();
  },

  methods: {
    insertTooltip() {
      if (!this.textTooltip) return;
      const tooltip = createTooltip({
        showCloseBtn: true,
        notDestroyOnClose: true,
        text: this.textTooltip,
        type: 'info-msg',
        position: 'info-msg',
      });
      if (!tooltip?.selector) return;
      if (!this.$refs.PriceMsgTooltip.appendChild(tooltip.selector)) return;
      this.tooltip = tooltip;
    },
    handleShowTooltip() {
      this.tooltip?.show();
    },
    handleHideTooltip() {
      this.tooltip?.hide();
    },
  },
};
</script>
